<style>
  .shoppingList .ui-widget-header {
    height: auto !important;
    padding: .25em .5em !important;    
    text-align: center !important;    
    font-size: 14px !important;    
  }

  .listInfo{
    background-color: #26437a;
    color: #fff;
    border-radius: 5px;    
    position: relative;
    font-size:16px;
    text-align: center;
    padding:10px;
  }

  .listInfo h3, .listInfo h4{
    margin:0;    
  }

  .listButtons{
    padding:20px 0;
  }

  .noProducts, .noLists{
    padding:20px;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
  }
 
</style>

<div class="shoppingList">

  <div class="customerList" *ngIf="mode == 'list'">
      <div class="noLists" *ngIf="shoppinginfoItems && shoppinginfoItems.length == 0">{{ 'shoppingList.no_lists' | translate }}</div>
      <app-kontable *ngIf="shoppinginfoItems && shoppinginfoItems.length > 0"
      id="dt_shopping"
      title="{{ 'shoppingList.listTitle' | translate }}"
      [columns]="['id','store_id','list_name']"
      [titles]="['shoppingList.list_id','shoppingList.store_id','shoppingList.list_name']"
      [source]="shoppinginfoItems"
      [showGlobalFilter]="false"
      [showDetailsButton]="true"
      [showInfoButton]="true"
      [showRecoverButton]="false"
      [showAddButton]="false"
      [showEditButton]="false"     
      (onRemove)="onClickListDelete($event)"
      (onDetails)="onClickListDetails($event)"
    ></app-kontable>
  </div>

  <div class="listDetails" *ngIf="currentList && storeInfo && mode == 'details'">
      <div class="listButtons">
          <button pButton type="button" class="k-generic-btn" icon="fa fa-arrow-left" iconPos="left"
          label="{{ 'shoppingList.backToLists' | translate }}" (click)="onClickBack()"></button>
      </div>
      <div class="listInfo">
        <h3>{{ currentList.list_name }}</h3>
        <h4>{{ 'shoppingList.storeName' | translate }}: <span *ngIf="storeInfo.code">{{ storeInfo.code }} - </span><span *ngIf="storeInfo.name">{{storeInfo.name}}</span><span *ngIf="storeInfo.address_1">- {{ storeInfo.address_1 }} </span><span *ngIf="storeInfo.address_number">{{storeInfo.address_number}}</span></h4>
      </div>

      <br />
      <div class="products">
        <br />
          <div class="noProducts" *ngIf="currentList && currentList.listDetails && currentList.listDetails.length == 0">{{ 'shoppingList.no_products' | translate }}</div>
          <app-kontable *ngIf="currentList && currentList.listDetails && currentList.listDetails.length > 0"
          id="dt_shopping"
          title="{{ 'shoppingList.products' | translate }}"
          [columns]="['id','item_id','item_bcd','item_descr','item_type','qty','flg_purchased']"
          [titles]="['shoppingList.product_id','shoppingList.item_id','shoppingList.item_bcd','shoppingList.item_descr','shoppingList.item_type','shoppingList.qty','shoppingList.flg_purchased']"
          [source]="currentList.listDetails"
          [showGlobalFilter]="false"
          [showDetailsButton]="false"
          [showInfoButton]="false"
          [showRecoverButton]="false"
          [showAddButton]="false"
          [showEditButton]="false"
          [showDeleteButton]="false"
        ></app-kontable>
      </div>

  </div>
    
</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/shoppinginfo/shoppinginfo.component.html